import { Component, AfterViewInit, Output, EventEmitter } from '@angular/core';
import { Asset } from '../../context-discovery-services/models';
import { Point } from '../../context-discovery-services/models/point.model';


@Component({
  selector: 'adminapp-generic-filter',
  templateUrl: './generic-filter.component.html',
  styleUrls: ['./generic-filter.component.scss']
})
export class GenericFilterComponent implements AfterViewInit {

  searchInput: any;
  genericFilterSelect: any;
  constructor() { }

  @Output()
  assetSearchPerformed: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  pointSearchPerformed: EventEmitter<any> = new EventEmitter<any>();


  ngAfterViewInit(): void {
    this.genericFilterSelect = document.getElementById('genericFilterSelect');
    if (this.genericFilterSelect) {
      this.genericFilterSelect.value = 'all';
    }
    this.searchInput = document.getElementById('searchInput');
    this.genericFilterSelect = document.getElementById('genericFilterSelect');
    if (this.searchInput != null) {
      this.searchInput.addEventListener('keypress', this.searchHandler.bind(this));
    }
  }

  searchClicked() {
    this.commonHandler(this.searchInput.value);
  }

  searchHandler(e) {
    const enterKeyCode = 13;
    if (e.keyCode === enterKeyCode) {
      const query = e.target.value;
      if (query == null) {
        return;
      } else {
        this.commonHandler(query);
      }
    }
  }

  commonHandler(query: string) {
    let regExp;
    try {
      regExp = new RegExp(query, 'i');
    } catch (e) {// invalid regular expression
      return;
    }
    switch (this.genericFilterSelect.value) {
      case 'name':
        this.emitSearchByNameEvents(regExp);
        break;
      case 'desc':
        this.emitSearchByDescEvents(regExp);
        break;
      case 'all':
        this.emitSearchByAllEvents(regExp);
    }
  }

  emitSearchByNameEvents(regExp) {
    this.assetSearchPerformed.emit((asset: Asset) => {
      return this.searchAssetByName(regExp, asset);
    });
    this.pointSearchPerformed.emit((point: Point) => {
      return this.matchPointByName(regExp, point);
    });
  }

  emitSearchByDescEvents(regExp) {
    this.assetSearchPerformed.emit((asset: Asset) => {
      return this.searchAssetByDesc(regExp, asset);
    });
    this.pointSearchPerformed.emit((point: Point) => {
      return this.matchPointByDesc(regExp, point);
    });
  }

  emitSearchByAllEvents(regExp) {
    this.assetSearchPerformed.emit((asset) => {
      return this.searchAssetByAll(regExp, asset);
    });
    this.pointSearchPerformed.emit((point) => {
      return this.searchPointByAll(regExp, point);
    });
  }

  searchAssetByName(regExp, asset) {
    return regExp.test(asset.label) ||
      asset.points.some(point => {
        return this.matchPointByName(regExp, point);
      });
  }

  searchAssetByDesc(regExp, asset) {
    return asset.points.some(point => {
      return this.matchPointByDesc(regExp, point);
    });
  }

  searchAssetByAll(regExp, asset) {
    return this.matchAssetByName(regExp, asset) || asset.points.some(point => {
      return (this.matchPointByName(regExp, point) || this.matchPointByDesc(regExp, point));
    });
  }

  searchPointByAll(regExp, point) {
    if (point.asset) {
      return this.matchPointByName(regExp, point) || this.matchPointByDesc(regExp, point) || regExp.test(point.asset.label);
    } else {
      return this.matchPointByDesc(regExp, point) || this.matchPointByName(regExp, point);
    }
  }

  matchAssetByName(regExp, asset) {
    return regExp.test(asset.label);
  }

  matchPointByName(regExp, point) {
    return regExp.test(point.label);
  }

  matchPointByDesc(regExp, point) {
    return regExp.test(point.comment);
  }

}
